import {AccordionContent, AccordionItem, AccordionTrigger} from "@/components/ui/accordion.tsx";
import {Badge} from "@/components/ui/badge.tsx";
import {Accordion} from "@/components/ui/accordion";
import React, {PropsWithChildren} from "react";
import {useExtensionEditDrawer} from "@/pages/extensions/components/ProviderExtensionEdit.tsx";


export function DrawerAccordion(props: PropsWithChildren) {

    const{setSectionsState, sectionsState} = useExtensionEditDrawer()

    return (
        <Accordion
            type="multiple"
            value={sectionsState}
            onValueChange={setSectionsState}
            className="max-w-full"
        >
            {props.children}
        </Accordion>
    )
}

type DrawerAccordionItemProps = PropsWithChildren<{
    value: string,
    title: string,
    icon: React.ElementType

}>

export const DrawerAccordionItem = (props: DrawerAccordionItemProps) => {

    const {title, value, icon: Icon, children} = props;

    return (
        <AccordionItem value={value} className="border-b border-gray-200 max-w-full">
            <AccordionTrigger className="cursor-pointer hover:bg-gray-100/40 rounded-none hover:no-underline flex justify-between items-center px-6 py-8">
                <div className="flex gap-4 items-center">
                    <Badge size="xs" variant="outline" className="[&>svg]:size-3.5 p-1 border bg-gray-100 border-gray-200">
                        <Icon className="size-8 text-gray-500"/>
                    </Badge>
                    <div className="text-sm font-medium">{title}</div>
                </div>
            </AccordionTrigger>
            <AccordionContent className="px-6">
                {children}
            </AccordionContent>
        </AccordionItem>
    )
}